<template>
    <div>
        <p>Sign-in in progress</p>
    </div>
</template>

<script>
    export default {
        async created() {
            try {
                var result = await this.$store.dispatch('signinRedirectCallback');
                var returnToUrl = '/monitor';
                if (result.state !== undefined) { returnToUrl = result.state;}
                this.$router.push({ path: returnToUrl });
            } catch (e) {
                console.log(e);
                this.$router.push({ name: 'Unauthorized' });
            }
        }
    }
</script>